export default {
  end_at: 'indtil d. {endDate}',
  today: 'I dag',
  day: 'Dag',
  month: 'Måned',
  week: 'Uge',
  five_days: '5 dage',
  all_day: 'Hele dagen',
  all_day_short: 'Heldag',
  events: 'Begivenheder',
  holiday: 'Ferie/fri',
  vacation_registration: 'Ferieanmodning',
  vacation_request: '@:calendar.vacation_registration: {coming}/{total} kommer',
  other_events: 'Andet',
  parental_meeting: 'Forældresamtale',
  performance_meeting: 'MUS-samtale',
  school_home_meeting: 'Skole-hjem-samtale',
  excursion: 'Ekskursion',
  birthday: 'Fødselsdag',
  lesson: 'Skema',
  selected_locations: 'Valgte lokaler',
  selected_resources: 'Valgte ressourcer',
  resources: 'Ressourcer',
  no_events: 'Ingen begivenheder',
  accepted: 'Deltag',
  tentative: 'Måske',
  declined: 'Afvis',
  update_answer: 'Opdater svar',
  private_event: 'Privat begivenhed',
  available_seats: 'ledig plads | ledige pladser',
  available_timeslots: 'ledig tid | ledige tider',
  response_accepted: 'Du har accepteret begivenheden',
  response_declined: 'Du har afvist begivenheden',
  response_tentative: 'Du har besvaret begivenheden',
  response_changed: 'Svar opdateret',
  response_deadline: 'Deadline for svar: {date}',
  note_to_class: 'Note til klasse',
  note_to_teacher: 'Note til lærer',
  note_to_substitute: 'Note til vikar',
  note_and_attachments: 'Noter og vedhæftninger',
  lesson_teacher: 'Underviser',
  lesson_assistance: 'Hjælpelærer',
  lesson_substitute: 'Vikar',
  lesson_pedagogue: 'Pædagog',
  primary_location: 'Primær lokale',
  locations: 'Lokaler',
  meeting_place: 'Mødested (fritekst)',
  change_timeslot: 'Skift tidspunkt',
  decline_meeting: 'Afslå samtale for mit barn',
  original_time: 'Original tid',
  new_time: 'Ny tid',
  substitute_teacher: 'Vikar',
  feed_overview_employee_year_feed_description:
    'Linket overfører alle de valgte typer af kalenderbegivenheder fra Aula fra en måned før dags dato og et år frem. Ændringer til kalenderen vil blive opdateret en gang i døgnet eller så ofte som dit kalenderprogram tillader. Du kan altid redigere eller slette kalenderlinket.',
  feed_overview_guardian_year_feed_description_for_guardian:
    'Linket overfører alle de valgte typer af kalenderbegivenheder du er inviteret til eller du selv har oprettet i Aula fra en måned før dags dato og et år frem. Ændringer til kalenderen vil blive opdateret en gang i døgnet eller så ofte som dit kalenderprogram tillader. Du kan altid redigere eller slette kalenderlinket.',
  feed_overview_guardian_year_feed_description_for_child:
    'Linket overfører alle de valgte typer af kalenderbegivenheder i Aula fra en måned før dags dato og et år frem. Ændringer til kalenderen vil blive opdateret en gang i døgnet eller så ofte som dit kalenderprogram tillader. Du kan altid redigere eller slette kalenderlinket.',
  create_link_title: 'Opret links til kalendersynkronisering',
  link_synchronize_employee_description:
    'Her kan du oprette links til kalendersynkronisering for dine kalenderbegivenheder i Aula. Når du har oprettet links til kalendersynkroniseringen, kan du kopiere dem over i en ekstern kalenderkonto. Vær opmærksom på, at der skal oprettes links pr. institution til kalendersynkroniseringen.',
  link_synchronize_guardian_description:
    'Her kan du oprette links til kalendersynkronisering for dine børns kalenderbegivenheder i Aula. Når du har oprettet et link til kalendersynkronisering, kan du kopiere det over i en ekstern kalenderkonto. Vær opmærksom på, at der skal oprettes et link pr. barn til kalendersynkronisering.',
  link_synchronize_employee_warning:
    'BEMÆRK! Årskalender og Ugekalender skal bruges sammen, så husk at kopiere begge links over i din eksterne kalenderkonto. Visse kalenderkonti er længere om at opdatere end oplyst nedenfor grundet begrænsninger hos udbyderen. Google oplyser eksempelvis, at der kan gå op til 12 timer før deres kalenderkonti opdaterer.',
  link_synchronize_guardian_warning:
    'BEMÆRK! Visse kalenderkonti er længere om at opdatere end oplyst nedenfor grundet begrænsninger hos udbyderen. Google oplyser eksempelvis, at der kan gå op til 12 timer før deres kalenderkonti opdaterer.',
  timeslot_is_already_booked_warning: 'Den valgte tid er allerede optaget.',
  therefore_choose_a_new_time: 'Vælg derfor en ny tid.',
  repeating_event: 'Gentagende begivenhed',
  exception_repeating_event: 'Ændret forekomst i gentagende begivenhed',
};
